import React from 'react';
import { Check, Pencil, Trash2 } from 'lucide-react';
import type { EventExpense, EventExpenseCategory } from '../../../../api/types';
import { EXPENSE_CATEGORIES, EXPENSE_CATEGORY_COLORS } from '../../../../utils/expense';
import { formatCurrency } from '../../../../utils/format';

export function ExpenseRow({ expense, excluded, onEdit, onDelete, onTogglePaid }: {
  expense: EventExpense; excluded?: boolean;
  onEdit: () => void; onDelete: () => void; onTogglePaid: () => void;
}) {
  const color = EXPENSE_CATEGORY_COLORS[expense.category];
  const amount = expense.amountActual != null ? Number(expense.amountActual) : Number(expense.amountEstimated);
  const hasActual = expense.amountActual != null && Number(expense.amountActual) !== Number(expense.amountEstimated);
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.625rem 0', borderBottom: '1px solid rgba(255,255,255,0.08)', opacity: excluded ? 0.55 : 1 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.625rem', flex: 1, minWidth: 0 }}>
        <span style={{ fontSize: '10px', fontWeight: 700, whiteSpace: 'nowrap', flexShrink: 0, color, background: 'oklch(from currentColor l c h / 0.12)', padding: '0.0625rem 0.375rem', borderRadius: 'var(--radius-interactive)' }}>
          {EXPENSE_CATEGORIES.find(c => c.value === expense.category)?.label ?? expense.category}
        </span>
        <div style={{ minWidth: 0 }}>
          <span style={{ fontSize: 'var(--text-sm)', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{expense.description}</span>
          {expense.notes && <span style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-faint)', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{expense.notes}</span>}
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0, marginLeft: '0.75rem' }}>
        <div style={{ textAlign: 'right' }}>
          {hasActual && <span style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-faint)', textDecoration: 'line-through', display: 'block' }}>{formatCurrency(expense.amountEstimated)}</span>}
          <span style={{ fontSize: 'var(--text-sm)', fontWeight: 600, color: excluded ? 'var(--color-text-faint)' : 'var(--color-text)' }}>{formatCurrency(amount)}</span>
        </div>
        <button
          title={expense.isPaid ? 'Segna come non pagata' : 'Segna come pagata'}
          onClick={onTogglePaid}
          style={{ background: expense.isPaid ? 'var(--color-success)' : 'none', border: `1px solid ${expense.isPaid ? 'var(--color-success)' : 'rgba(255,255,255,0.10)'}`, borderRadius: 'var(--radius-interactive)', cursor: 'pointer', color: expense.isPaid ? '#fff' : 'var(--color-text-faint)', padding: '0.25rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Check size={11} />
        </button>
        <button onClick={onEdit} title="Modifica" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--color-text-faint)', padding: '0.125rem', display: 'flex' }}><Pencil size={13} /></button>
        <button onClick={onDelete} title="Elimina" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--color-text-faint)', padding: '0.125rem', display: 'flex' }}><Trash2 size={13} /></button>
      </div>
    </div>
  );
}
